import React from 'react';
import { IonContent, IonPage, IonButton, IonHeader, IonToolbar, IonIcon, IonImg, IonText } from '@ionic/react';
import { useHistory } from "react-router-dom";
import { remove } from '../services/storage.service';
import FooterComponent from "../components/FooterComponent";
import LoginCheck from "../components/LoginCheck";
import { logOutOutline, chevronBackOutline } from 'ionicons/icons';
import './Mindset.css';

//import PostsContainer from "../components/Mindmaps/MindMapContainer";

const Plan: React.FC = () => {
    const history = useHistory();
    function logOut(){
      console.log("logout");
      remove('cred');
      history.push('/home');
    }
    function viewMindmap(){
      history.replace('/viewmindmap');
      window.location.reload();
    }
    return (
        <>
        <IonPage>
        <LoginCheck/>
        <IonHeader translucent={true} >
        <IonToolbar>
       <IonButton size="small" slot="start" color="primary" onClick={() => history.push("/dashboard/")} className="back"><IonIcon slot="start" icon={chevronBackOutline}/>Back</IonButton>
        <IonButton size="small" slot="end" color="primary" onClick={() => logOut()}  class="logout"><IonIcon slot="end" icon={logOutOutline}/>Log Out</IonButton>
        </IonToolbar>
      </IonHeader>
            <IonContent className="ion-text-center maintext">
            <IonText className="headerimage">
            <IonImg src="../assets/images/tablet/mindmap-tablet.png" alt="Mindset" className="tablet-image"/>
            <IonImg src="../assets/images/mobile/mindmap-head-phone.png" alt="Mindset" className="phone-image"/>
            </IonText>
            <IonText className="topbrowntext">Now that you've customized your Explorer Mindset it's time to plan a learning expedition!</IonText>
            <IonText className="greentext">Launch the planning tool to create your mind map</IonText>
              <IonButton routerLink="/createmindmap" className="pagebutton" expand="full" shape="round" target="_self">Plan an expedition</IonButton>
              <IonButton className="pagebutton" expand="full" shape="round" target="_self" onClick={()=>viewMindmap()}>View Mind Maps</IonButton>
            <IonText className="browntext">Be just as empowered by how you learn as what you learn</IonText>
            <IonImg src="../assets/images/Mindmap_Home_Bottom_03.png" alt="mindsetstripes"/>
        </IonContent>
        <FooterComponent/>
      </IonPage>
      </>
    );
};
 
export default Plan;